// Detects whether the app is running inside the Capacitor Android wrapper
// (i.e. installed APK from Play Store) vs a regular browser tab / PWA.
//
// Google Play forbids digital purchases via 3rd-party payment systems INSIDE
// the app's WebView, but Spotify/Netflix-style flow is allowed:
// open the external system browser, complete payment there, return to app.
//
// We use this flag to:
//   - keep the camera & gallery experience unchanged
//   - re-route the Stripe Checkout link through the system browser
//     (window.open in Capacitor's bridge automatically opens the system
//      browser when the target host differs from the bridged origin)

export function isCapacitorNative() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
  return cap.platform === "android" || cap.platform === "ios";
}

// Open an external URL in the system browser when running in Capacitor,
// otherwise navigate the current tab (web). Used for the Stripe Checkout
// redirect so that Play Store compliance is preserved.
export function openExternal(url) {
  if (!url) return;
  if (isCapacitorNative()) {
    // Capacitor 7 bridge routes cross-origin window.open(_blank) to the
    // system browser intent. Avoids embedding payment UI in the APK WebView.
    window.open(url, "_blank");
    return;
  }
  window.location.href = url;
}
